var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIdea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M34.2195 27.609L32.1075 29.718L35.25 32.859L37.359 30.75L34.218 27.609H34.2195ZM61.782 27.609L58.6395 30.75L60.75 32.859L63.891 29.7195L61.782 27.609ZM48 28.545C47.505 28.551 47.004 28.5795 46.5 28.641C46.485 28.641 46.47 28.638 46.455 28.641C40.371 29.3385 35.529 34.254 34.6875 40.311C34.0155 45.186 36.0255 49.6065 39.375 52.4535C40.7451 53.6228 41.6718 55.2274 42 56.9985V65.9985H45.42C45.942 66.894 46.8945 67.4985 48 67.4985C49.1055 67.4985 50.058 66.894 50.58 65.9985H54V59.9985H54.141V58.2165C54.141 56.0175 55.284 53.8005 57.141 52.077C59.625 49.59 61.5 46.0575 61.5 42C61.5 34.59 55.401 28.476 48 28.545ZM48 31.545C53.7975 31.464 58.5 36.21 58.5 42C58.5 45.141 57.045 47.907 55.0305 49.92L55.0785 49.968C53.0766 51.8141 51.7821 54.3012 51.4185 57H44.8575C44.5275 54.429 43.425 51.9405 41.3415 50.1555C38.691 47.9055 37.1115 44.5155 37.6395 40.6875C38.295 35.9625 42.129 32.163 46.827 31.6425C47.2149 31.5884 47.6055 31.5564 47.997 31.5465L48 31.545ZM27 42V45H31.5V42H27ZM64.5 42V45H69V42H64.5ZM35.25 54.141L32.109 57.2805L34.2195 59.391L37.3575 56.25L35.25 54.141ZM60.75 54.141L58.641 56.25L61.7805 59.391L63.891 57.2805L60.75 54.141ZM45 60H51V63H45V60Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIdea);
export default __webpack_public_path__ + "static/media/idea.100970d7bddfbddc0e2e44c40588bf37.svg";
export { ForwardRef as ReactComponent };